// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
export const getValidateAmountMessage =
  (action: string, currBalance?: string) => (inputAmount: string) => {
    if (currBalance === undefined) {
      return '';
    }
    const input = parseFloat(inputAmount);
    const currentBalance = parseFloat(currBalance);
    if (input > currentBalance) {
      return `${action} amount exceeds current holding balance`;
    }
    return '';
  };
